import React from 'react';
import { Box, Typography } from '@mui/material';

const LogoTitle = () => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <Typography sx={{ fontFamily: "'Arial', sans-serif", fontSize: '34px' }}>
      Racklet
    </Typography>
    <Typography
      sx={{
        fontFamily: "'Arial', sans-serif",
        fontSize: '34px',
        backgroundColor: '#66B2FF',
        color: 'white',
        borderRadius: '124px',
        marginLeft: '8px',
        padding: '0 9px',
      }}
    >
      AI
    </Typography>
  </Box>
);

export default LogoTitle;